import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceTaxClassesEntityState} from "../reducers/ecommerce-tax-classes.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceTaxClassesState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceTaxClasses.entities[websiteId]);

export const getEcommerceTaxClassesFilter = (websiteId: number) => createSelector(getEcommerceTaxClassesState(websiteId),
  (state: IEcommerceTaxClassesEntityState) => {
    return state?.filterData ? state.filterData : [];
  }
);
export const getEcommerceTaxClasses = (websiteId: number) => createSelector(getEcommerceTaxClassesState(websiteId),
  (state: IEcommerceTaxClassesEntityState) => {
    return state?.data ? state.data : [];
  }
);

export const getEcommerceTaxClassesLoading = (websiteId: number) => createSelector(getEcommerceTaxClassesState(websiteId),
  (state: IEcommerceTaxClassesEntityState) => state && state.loading
);

export const getEcommerceTaxClassesLoaded = (websiteId: number) => createSelector(getEcommerceTaxClassesState(websiteId),
  (state: IEcommerceTaxClassesEntityState) => state && state.loaded
);
